import { render, staticRenderFns } from "./WaybillRequest.vue?vue&type=template&id=4ec042c9&scoped=true&"
import script from "./WaybillRequest.vue?vue&type=script&lang=js&"
export * from "./WaybillRequest.vue?vue&type=script&lang=js&"
import style0 from "./WaybillRequest.vue?vue&type=style&index=0&id=4ec042c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec042c9",
  null
  
)

export default component.exports